import { render, staticRenderFns } from "./Populate.vue?vue&type=template&id=65b6898b&lang=pug"
import script from "./Populate.vue?vue&type=script&lang=js"
export * from "./Populate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports